/**
 * SCHEMAS: VEHICLE
 * Schémas de validation Zod pour les véhicules
 */

import { z } from 'zod';

export const createVehicleSchema = z.object({
  registration: z
    .string()
    .min(1, "L'immatriculation est requise")
    .max(20, "L'immatriculation ne peut pas dépasser 20 caractères"),
  crew_id: z.string().optional(),
  circulation_date: z.string().optional(),
  notes: z.string().optional(),
  owner: z.string().optional(),
});

export type CreateVehicleInput = z.infer<typeof createVehicleSchema>;
